import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';

export default class NodeDuplicate extends Node
{
	constructor(pParent)
	{
		super(pParent);
		
		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);
		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'duplicate';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{		
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		if(!Array.isArray(pGeoList))
			return null;
		
		let pNewMeshes = [];
		let iCounter = 0;
		for(let pSrcMesh of pGeoList)
		{
			let pNewMesh = Utils3D.cloneMesh(pSrcMesh, this.getGeneratedMeshName() + "_" + iCounter);
			this.onMeshCreated(pNewMesh);
			iCounter++;
			pNewMeshes.push(pNewMesh);
		}

		return pNewMeshes;
	}
}